import React, { PropsWithChildren, useContext } from 'react';

import { AuthContext } from './AuthRouter';

export default function NotAuthenticated({ children }: PropsWithChildren) {
  const { user, loading } = useContext(AuthContext);

  return !user && !loading ? <>{children}</> : null;
}
